import { Link } from "react-router-dom";
import { TREATMENT_CARDS, treatmentCardImage } from "@/data/treatmentCards";
import { trackTreatmentView } from "@/utils/treatmentTracking";

// Responsive photo-card grid: 2 across on phones, 3 on tablets, 4 on desktop
// (override with `cols`). Every card is one tap target → treatment page.
export function TreatmentPhotoGrid({ lang = "en", onNavigate, cols = "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4", compact = false, className = "", testIdPrefix = "treatment-card" }) {
  const l = lang === "fr" ? "fr" : "en";
  return (
    <div className={`grid ${cols} ${compact ? "gap-3" : "gap-4 sm:gap-5 lg:gap-6"} ${className}`} data-testid={`${testIdPrefix}-grid`}>
      {TREATMENT_CARDS.map((c, i) => (
        <Link
          key={c.key}
          to={c.href}
          onClick={() => {
            trackTreatmentView({ slug: c.href.replace(/^\//, ""), label: c.name.en, href: c.href });
            onNavigate?.();
          }}
          className="group block no-underline text-current focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 rounded-2xl"
          data-testid={`${testIdPrefix}-${c.key}`}
        >
          <div className="aspect-square w-full overflow-hidden rounded-2xl ring-1 ring-black/5 shadow-md group-hover:shadow-xl transition-shadow" style={{ border: "2px solid rgba(201,163,90,0.55)" }}>
            <img
              src={treatmentCardImage(c.key)}
              alt={c.name[l]}
              width={640}
              height={640}
              loading={i < 4 ? "eager" : "lazy"}
              decoding="async"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
            />
          </div>
          <p className={`mt-2 font-bold text-zinc-900 leading-tight ${compact ? "text-[12.5px]" : "text-[13.5px] sm:text-[15px]"}`}>
            {c.name[l]}
          </p>
          <p className={`mt-0.5 text-zinc-500 leading-snug ${compact ? "text-[11px] line-clamp-2" : "text-[12px] sm:text-[13px]"}`}>
            {c.blurb[l]}
          </p>
        </Link>
      ))}
    </div>
  );
}
